import React from 'react'
import { fadeIn } from 'react-animations'
import styled, { keyframes } from 'styled-components';

const Instructions = (props) => {
    const a1 = keyframes`${fadeIn}`;
    const AnimateContent = styled.div`animation: 2s ${a1};`;
    
  return (
    <div className="instructions">
        <p>On the next page, you will see 8 situations that you’re likely to face in your role. You need to respond to each question to build your personalised leadership assessment report.</p>
        <p>The report, apart from being robust & accurate, is designed to trigger leadership development. It gives you insights on how much & where you demonstrated  leadership competencies in your response to the situations. It is generated by an an artificial intelligence technology – IBM Watson. Watson is IBM’s machine learning technology that has the potential to learn from human data and provide previously hard to identify insights.</p>
        <p><b>Please keep the following in mind:</b></p>
        <AnimateContent>
        <ul className="list-group">
            <li className="list-group-item">Copy and paste feature is disabled.</li>
            <li className="list-group-item">Do not use following charactrs - '#', '\', '@', '$', '~', '`', '•', '{', '}', '&lt;',  '&gt;', '*', '^', '|', '[', ']', '“', '”' while you typing your response.</li>
            <li className="list-group-item">Each response should be of minimum 80 words.</li>
            <li className="list-group-item">Full stops only to be used at the end of the sentence.</li>
            <li className="list-group-item">Do not use bullets and numbers.</li>
            <li className="list-group-item">Do not leave the assessment window open without activity for too long. It might show error when you return to it.</li>
            <li className="list-group-item">Please respond with the actions you will take in the situation and not with your thoughts and views. Specific actions that you would take in the situation.</li>
        </ul> 
        </AnimateContent>
    </div>
  )
}

export default Instructions